import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'
import { AuthService } from '@shared/services/auth.service'
import { Observable } from 'rxjs'
import { Injectable } from '@angular/core'

@Injectable()
export class AuthGuardService  {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (this.authService.isLoggedIn()) {
      return true
    }

    this.router.navigate(['/login'])
    return false
  }
}
